import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FormValidationService} from '../../../services/form-validation.service';
import {AuthService} from '../../../services/auth.service';
import {HttpErrorResponse} from '@angular/common/http';
import {Subscription} from 'rxjs/Subscription';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styles: [`
    .secondary-title {
      max-width: 340px;
      line-height: 25px;
      margin: 5px 0 15px;
    }
    .email {
      color: #26c6da;
    }
    form {
      display: flex;
      flex-direction: column;
      width: 320px;
    }
    app-button {
      margin: 10px auto 25px;
    }
  `]
})
export class ResetPasswordComponent {
  reseted = false;
  submitted = false;
  form: FormGroup;
  error: string;
  showOverlay = false;
  valueChangesSubscription: Subscription;
  httpRequestSubscritpion: Subscription;
  email: string;

  constructor(
    private validationService: FormValidationService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.email
      ]),
    });

    this.valueChangesSubscription = this.form.valueChanges.subscribe(() => this.error = '');

  }

  ngOnDestroy() {
    this.valueChangesSubscription.unsubscribe();
    // this.httpRequestSubscritpion.unsubscribe();
  }

  resetPassword() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    this.showOverlay = true;
    this.httpRequestSubscritpion = this.authService.resetPassword({email: this.form.get('email').value})
      .subscribe(
        data => {
          this.reseted = true;
          this.email = data.email;
          this.showOverlay = false;
        },
        (error: HttpErrorResponse) => {
          this.error = error.error.message;
          this.showOverlay = false;
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/reset-password/reset-password.component.ts